/** Sections that can appear in the “send updates” confirmation list (Figma R5). */
export type SendOrderUpdatesSectionId =
  | 'clinicalSummary'
  | 'indications'
  | 'familyHistory'
  | 'guardianContact'
  | 'sequencingOptions'
  | 'comparatorParents'
  | 'patientConsent'
  | 'patientDemographics'

export const SECTION_LABELS: Record<SendOrderUpdatesSectionId, string> = {
  clinicalSummary: 'Clinical Summary was updated',
  indications: 'Indications for Testing were updated',
  familyHistory: 'Family History was updated',
  guardianContact: 'Guardian contact was updated',
  sequencingOptions: 'Sequencing option was updated',
  comparatorParents: 'Comparator details were updated',
  patientConsent: 'Patient consent was updated',
  patientDemographics: 'Patient details were updated',
}

/**
 * Short section names for the inline "pending changes" banner on the
 * OrderInProgress screen (e.g. "Clinical Summary, Sequencing option"). Kept
 * here alongside the full sentence labels so the two stay in sync.
 */
export const SEND_UPDATES_SECTION_SHORT_LABELS: Record<SendOrderUpdatesSectionId, string> = {
  clinicalSummary: 'Clinical Summary',
  indications: 'Indications for Testing',
  familyHistory: 'Family History',
  guardianContact: 'Guardian contact',
  sequencingOptions: 'Sequencing option',
  comparatorParents: 'Comparator details',
  patientConsent: 'Patient consent',
  patientDemographics: 'Patient details',
}
